import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";


export const getCopPageContentsData = async () => {
  let results = [];
  const limit = 100;
  const postAmount = 100;
  let page = 1;
  while (page < limit) {
    const url = ENDPOINTS.GET.COP_PAGE_CONTENTS.replace(
      "%POST_AMOUNT%",
      postAmount
    ).replace("%PAGE%", page);
    const chunk = await fetchData(url, {
      method: METHODS.GET,
    });
    results = [...results, ...chunk];
    if (chunk.length < postAmount) break;
    page += 1;
  }
  return results;
};
